import Menu from "../components/Menu";
import ImageZoom from "../components/ImageZoom";
import { motion, AnimatePresence } from "framer-motion";
import qr from "../images/qr.png";
import { Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";

export default function Contact() {
  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.0, ease: "easeOut" },
    },
  };

  return (
    <>
      <Menu />

      <section className="section section-gray section-about" key="sectiongray">
        <AnimatePresence>
          <motion.div
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={textVariants}
          >
            <Row key="row1">
              <Col sm={12} md={4}>
                <ImageZoom src={qr} alt="tomek" />
              </Col>
              <Col md={8}>
                <p className="h1a">
                  TOMASZ JASKULSKI
                  <br />
                  {/* NIP: 123-456-78-90
                <br /> */}
                  tel.:{" "}
                  <a
                    href="tel:+48570860088"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    +48 570 86 00 88
                  </a>
                  <br />
                  email:{" "}
                  <a
                    href="mailto:tomek@fotorealestate.pl"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    kontakt@tomaszfotograf.pl
                  </a>
                  <br />
                  https://tomaszfotograf.pl
                </p>
              </Col>
            </Row>
          </motion.div>
        </AnimatePresence>
      </section>
    </>
  );
}
